<template>
  <div>
    <div class="row section-bottom-spacing">
      <div class="col">
        <SectionTitle :content="'Acuerdos'" :has-line="true" />
        <div class="pl-3 pt-4">
          <div class="mb-3">
            <span>
              Posterior al análisis de la evaluación de Asistencia Tecnológica,
              el COMPU escolar los resultados de esta.
            </span>
          </div>
          <div class="pb-4 pr-2">
            <span>
              * De haber aceptado los resultados de la evaluación, el COMPU
              acuerda solicitar los siguientes equipos recomendados de ser
              necesarios, por considerar que son indispensables para el
              desarrollo de las metas y los objetivos trazados en el PEI del
              estudiante, y/o para su integración e inclusión en la sala regular
              de clases.
            </span>
          </div>
        </div>
        <div class="text-center mt-3">
          <div class="input-group d-inline">
            <input
              id="input1"
              v-model="model.isEvaluationAccepted"
              type="radio"
              :value="true"
              class="hidden"
              name="input"
              :disabled="readonly"
            />
            <label class="entry" for="input1">
              <div class="circle" />
              <div class="entry-label">Acepto</div>
            </label>

            <input
              id="input2"
              v-model="model.isEvaluationAccepted"
              type="radio"
              :value="false"
              class="hidden"
              name="input"
              :disabled="readonly"
            />
            <label class="entry" for="input2">
              <div class="circle" />
              <div class="entry-label">No Acepto</div>
            </label>
            <div v-if="model.isEvaluationAccepted !== null" class="highlight" />
          </div>
        </div>
      </div>
    </div>
    <div v-if="termsHasBeenAccepted" class="row section-bottom-spacing">
      <div class="col">
        <SectionTitle
          :content="'Recomendación de equipo por parte del CAAT'"
          :has-line="true"
        />
        <div class="container-table-striped">
          <div class="pl-3 pt-4">
            <p>
              ¿Es necesario la recomendación de Equipos de Asistencia
              Tecnológica para el Estudiante?:
              <span v-if="peiAtInformation.isRecomendationNeeded">
                <b>Si</b>
              </span>
              <span v-if="!peiAtInformation.isRecomendationNeeded">
                <b>No</b>
              </span>
            </p>
            <div
              v-if="!peiAtInformation.isRecomendationNeeded"
              class="pb-4 pr-2"
            >
              <strong>Comentario:</strong>
              <CustomTextArea
                v-show="true"
                :id="'isRecomendationNeeded'"
                v-model="peiAtInformation.recomendationNeededComment"
                style="width:100%"
                :maxlength="3000"
                :classes="['eq-field', 'text-left']"
                :rows="5"
                :disabled="readonly"
              />
            </div>
          </div>

          <div
            v-if="peiAtInformation.isRecomendationNeeded"
            class="table-hover"
          >
            <table class="table content-table-striped table-striped mb-5">
              <thead>
                <tr class="row global-thead-dark thead-property pl-1">
                  <th class="col-2">
                    Aceptado
                  </th>
                  <th class="col-3">
                    Categoría y Equipo
                  </th>
                  <th class="col-2">
                    Requiere compra
                  </th>
                  <th class="col-3">
                    Establecer escenario
                  </th>
                  <th class="col-2">
                    Requiere Adiestramiento
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in model.equipments"
                  :key="item.id"
                  class="row pl-2"
                >
                  <td class="col-md-2 pl-4">
                    <div class="input-group mb-3">
                      <input
                        :id="'check-' + item.recommendation.id"
                        v-model="item.isRecommended"
                        type="checkbox"
                        :name="'check-' + item.recommendation.id"
                        class="option-input checkbox"
                        :checked="item.isRecommended"
                        :disabled="readonly"
                      />
                      <label :for="'check-' + item.recommendation.id">
                        <span><i class="ic-check" /></span>
                      </label>
                    </div>
                  </td>
                  <td class="col-md-3 pl-4">
                    <span>{{ item.recommendation.categoryDescription }}</span>
                    <br />
                    <span class="bold">
                      {{ item.recommendation.equipmentName }}
                    </span>
                  </td>
                  <td class="col-md-2 pl-4">
                    <div class="input-group mb-3">
                      <input
                        :id="'isBuyRequired-' + item.recommendation.id"
                        v-model="item.isBuyRequired"
                        type="checkbox"
                        :name="'isBuyRequired-' + item.recommendation.id"
                        class="option-input checkbox"
                        :checked="item.isBuyRequired"
                        :disabled="readonly"
                      />
                      <label :for="'isBuyRequired-' + item.recommendation.id">
                        <span><i class="ic-check" /></span>
                      </label>
                    </div>
                  </td>
                  <td class="col-md-3 pl-4">
                    <input
                      :id="'recommendedLocation-' + item.recommendation.id"
                      v-model="item.recommendedLocation"
                      type="text"
                      class="form-control"
                      :name="'recommendedLocation-' + item.recommendation.id"
                      :disabled="readonly"
                    />
                  </td>
                  <td class="col-md-2 pl-4">
                    <div class="input-group mb-3">
                      <input
                        :id="'isTrainingRequired-' + item.recommendation.id"
                        v-model="item.isTrainingRequired"
                        type="checkbox"
                        :name="'isTrainingRequired-' + item.recommendation.id"
                        class="option-input checkbox"
                        :checked="item.isTrainingRequired"
                        :disabled="readonly"
                      />
                      <label
                        :for="'isTrainingRequired-' + item.recommendation.id"
                      >
                        <span><i class="ic-check" /></span>
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SectionTitle } from '@/components/pei/shared';
import CustomTextArea from '@/components/common/CustomTextArea';
export default {
  props: {
    model: {
      type: Object,
      default: () => {},
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    peiAtInformation: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isValid: false,
    };
  },
  components: {
    SectionTitle,
    CustomTextArea,
  },
  methods: {
    validate() {
      this.errorMessage = '';
      this.isValid = true;

      if (this.model.isEvaluationAccepted == null) {
        this.errorMessage =
          'Favor de marcar los acuerdos de la evaluación de asistencia tecnológica.';
        this.isValid = false;
      } else if (
        this.model.isEvaluationAccepted &&
        this.peiAtInformation.isRecomendationNeeded
      ) {
        if (this.model.equipments.findIndex((x) => x.isRecommended) === -1) {
          this.errorMessage = this.getMessage('191350').name;
          this.isValid = false;
        }
      }

      this.$emit('changed', 3, this.isValid, this.errorMessage);
      return this.isValid;
    },
    onClickChild() {
      this.validate();
    },
    loadValidationMessages() {
      const messageCodes = ['191350'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    getMessage(code) {
      const message = this.validationMessages.find(
        (element) => element.id == code
      );
      return message;
    },
  },
  mounted() {
    this.validate();
  },
  computed: {
    termsHasBeenAccepted() {
      return this.model.isEvaluationAccepted;
    },
  },
  created() {
    this.loadValidationMessages();
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped src="@/assets/css/component/btn-dropdown.css"></style>
<style scoped src="@/assets/css/component/checkbox.css"></style>
<style scoped src="@/assets/css/component/radio-button.css"></style>

<style scoped>
.section-bottom-spacing {
  margin-bottom: 50px !important;
}

.section-left-spacing {
  margin-left: 10px;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.input-group .hidden {
  display: none;
}
.input-group .entry {
  height: 25px;
  position: relative;
  width: 110px;
}
.input-group .circle {
  border: 1px solid #e2e2e2;
  border-radius: 50%;
  cursor: pointer;
  height: 20px;
  position: absolute;
  transition: border-color 300ms;
  width: 20px;
}
.input-group .entry-label {
  cursor: pointer;
  font-weight: 800;
  margin-top: -3px;
  padding-left: 30px;
  user-select: none;
  -moz-user-select: none;
}
.input-group .highlight {
  background: #2db782;
  border-radius: 50%;
  height: 10px;
  left: 5px;
  pointer-events: none;
  position: absolute;
  top: 5px;
  transition: transform 400ms cubic-bezier(0.175, 0.885, 0.32, 1.2);
  transform: translateX(0px);
  width: 10px;
}
.input-group .hidden:nth-child(1):checked ~ .highlight {
  transform: translateY(0);
}
.input-group .hidden:nth-child(3):checked ~ .highlight {
  transform: translateX(110px);
}
.input-group .hidden:nth-child(1):checked + .entry .circle {
  border-color: #e2e2e2;
}
</style>
